module.exports = __webpack_public_path__ + "img/wallpaper.ecc512cf.png";